import React, { useEffect } from 'react';
import { CssBaseline } from '@mui/material';
import MainLayout from '../components/layout/MainLayout';
import ModuleWiseLayout from '../components/module-wise-layout';
import SEO from '../components/seo';
import useConfigData from '../hooks/useConfigData';
import { useDispatch } from 'react-redux';
import { setConfigData } from '../redux/slices/configData';

const Home = () => {
  const { configData, landingPageData, loading } = useConfigData();
  const dispatch = useDispatch();

  // Ensure configData is dispatched to Redux store for header/footer components
  useEffect(() => {
    if (configData) {
      dispatch(setConfigData(configData));
    }
  }, [configData, dispatch]);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <>
      <CssBaseline />
      <SEO
        title={configData?.business_name || '6ammart'}
        image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
        businessName={configData?.business_name || '6ammart'}
      />
      <MainLayout configData={configData} landingPageData={landingPageData}>
        <ModuleWiseLayout configData={configData} />
      </MainLayout>
    </>
  );
};

export default Home;